<template>
  <div class="body-container order-detail main" v-if="detail.id"
  :class="{
    'hide-btn':detail.orderStatus==1&&detail.checkInsuranceStatus==2||([3,5,6,8].includes(this.detail.orderStatus*1)&&detail.isReplaceInsure),
    'has-padding':!([3,4].includes(this.detail.policyStatus*1)) && !(pageFlag=='rhPage'&&detail.orderStatus==7)&& !([2,3,5,9,-9].includes(detail.orderStatus)&&pageFlag=='rhPage')
    }">
    <div class="top-box">
      <div class="text1">{{detail.productName}}</div>
      <div class="text3" v-if="detail.policyNo">
        <span class="title">保单号：</span>
        <span class="num">{{detail.policyNo}}</span>
        <span class="copy-btn" @click="$tools.copyText(detail.policyNo)">复制</span>
      </div>
      <div class="text3" v-else-if="orderNo">
        <span class="title">订单号：</span>
        <span class="num">{{detail.id}}</span>
        <span class="copy-btn" @click="$tools.copyText(detail.id)">复制</span>
      </div>
      <div class="text2">由{{detail.companyName}}承保</div>
      <div class="float-img" v-if="detail.policyNo">
        <img class="status-img" v-if="detail.isActive===0" src="@static/images/order/dsx.png">
        <img class="status-img" v-else-if="detail.policyStatus==1" src="@static/images/order/bzz.png">
        <img class="status-img" v-else-if="detail.policyStatus==3" src="@static/images/order/ytb.png">
        <img class="status-img" v-else-if="detail.policyStatus==4" src="@static/images/order/yzz.png">
      </div>
      <div :class="{'float-img1':detail.orderStatus==4,'float-img':detail.orderStatus!=4}" v-else-if="!policyNo && !detail.doubleRecordStatus || [5,6,8].includes(detail.orderStatus)">
        <!-- qualityStatus -1无需质检，0质检回复，1质检中，2质检成功，3质检失败  质检回复、质检中显示已支付-->
        <img class="status-img" v-if="detail.qualityStatus===0||detail.qualityStatus===1" src="@static/images/order/yzf.png">
        <img class="status-img" v-else-if="detail.orderStatus==1" src="@static/images/order/dzf.png">
        <img class="status-img" v-else-if="detail.orderStatus==2" src="@static/images/order/bzz.png">
        <img class="status-img" v-else-if="detail.orderStatus==3" src="@static/images/order/ytb.png">
        <img class="status-img" v-else-if="detail.orderStatus==4" src="@static/images/order/hbsb.png">
        <img class="status-img" v-else-if="detail.orderStatus==5" src="@static/images/order/ygq.png">
        <img class="status-img" v-else-if="detail.orderStatus==6" src="@static/images/order/ysx.png">
        <img class="status-img" v-else-if="detail.orderStatus==7" src="@static/images/order/rghb.png">
        <img class="status-img" v-else-if="detail.orderStatus==8" src="@static/images/order/ycd.png">
        <img class="status-img" v-else-if="detail.orderStatus==9" src="@static/images/order/kkcg.png">
        <img class="status-img" v-else-if="detail.orderStatus==-9" src="@static/images/order/kksb.png">
        <img class="status-img" v-else-if="detail.orderStatus==10" src="@static/images/order/icon-yhbcg.png">
        <img class="status-img" v-else-if="detail.orderStatus== -3" src="@static/images/order/icon-yhbsb.png">
      </div>
      <div class="float-img" v-else>
        <img class="status-img" v-if="detail.doubleRecordStatus=='0'" src="@static/images/order/icon-dsl.png">
        <img class="status-img" v-else-if="detail.doubleRecordStatus=='-1'" src="@static/images/order/icon-shsb.png">
        <img class="status-img" v-else-if="detail.doubleRecordStatus=='2'" src="@static/images/order/icon-shtg.png">
        <img class="status-img" v-else-if="detail.doubleRecordStatus=='1'" src="@static/images/order/icon-shz.png">
      </div>

      <div class="time-text" v-if="pageFlag=='orderOrPolicy'&&detail.orderStatus==1&&detail.expireTimeFormat">距离订单过期还有<span>{{detail.expireTimeFormat}}</span></div>
      <div class="time-text" v-if="pageFlag=='xfFlag'&&detail.policyStatus==1&&detail.needRenewalDesc"><span>{{detail.needRenewalDesc}}</span></div>
      <div class="time-text" v-if="detail.orderStatus==4&&detail.message"><img src="@static/images/order/error.png">{{detail.message}}</div>
    </div>
    <!-- 加保 -->
    <addPolicy :detail="detail" v-if="detail&&detail.addPolicy"></addPolicy>
    <!-- 质检回复 -1无需质检，0质检回复，1质检中，2质检成功，3质检失败 -->
    <qualityBox :detail="detail" v-if="detail&&[0,1,3].includes(detail.qualityStatus)"></qualityBox>
    <div class="box">
      <div class="box-title">基本信息</div>
      <div class="text">
        <span class="label">投保时间</span>
        <span>{{detail.createTime | timeStatus}}</span>
      </div>
      <div class="text">
        <span class="label">保障期限</span>
        <span>自{{detail.startTime |timeSplit}}起至{{detail.endTime |filterEndTime}}</span>
      </div>
      <div class="text">
        <span class="label">保费</span>
        <span>{{detail.fee|filterFee}}元</span>
      </div>
      <div class="text" >
        <span class="label">交费期限</span>
        <span>{{detail.payDesc}}</span>
      </div>
      <div class="text" v-if="detail.renewalDesc && pageFlag=='xfFlag'">
        <span class="label" v-if="policyType==2">续费状态</span>
        <span class="label" v-if="policyType==1">续保状态</span>
        <span>{{detail.renewalDesc}}</span>
      </div>

    </div>
    <div class="box">
      <div class="box-title">投保人</div>
      <div class="text">
        <span class="label">姓名</span>
        <span>{{detail.policyerName}}</span>
      </div>
      <div class="text">
        <span class="label">证件类型</span>
        <span>{{detail.policyerCardType|identifyType}}</span>
      </div>
      <div class="text">
        <span class="label">证件号码</span>
        <span>{{detail.policyerIdCard}}</span>
      </div>
      <div class="text">
        <span class="label">手机号码</span>
        <span>{{detail.policyerMobile}}</span>
      </div>
      <div class="text">
        <span class="label">电子邮箱</span>
        <span>{{detail.policyerEmail}}</span>
      </div>
      <div class="text" v-if="detail.doubleRecordStatus && ![5,6,8].includes(detail.orderStatus)">
        <span class="label">双录状态</span>
        <span>{{ detail.doubleRecordStatus | filterDoubleRecordStatus }}</span>
      </div>
    </div>
    <div class="box">
      <div class="box-title">被保险人
        <span class="btn" v-if="insuresList.length==1" @click="goBzqy()">查看权益 ></span>
        <!-- <span v-else>（共{{insuresList.length}}人）</span> -->
       </div>
      <div v-for="(bean,i) in insuresList" :key="i" class="text-item">
        <div class="text num" v-if="insuresList.length>1">
          <span class="label">被保险人{{i+1}}</span>
          <div class="btn" v-if="insuresList.length!=1" @click="goBzqy(bean.insurederIdCardMd5)">查看权益 ></div>
        </div>
        <div class="text">
          <span class="label">与投保人关系</span>
          <span>{{bean.insuredRelationship | filterRelationShip}}</span>
        </div>
        <div class="text">
          <span class="label">姓名</span>
          <span>{{bean.insurederName}}</span>
        </div>
        <div class="text">
          <span class="label">证件类型</span>
          <span>{{bean.insurederCardType|identifyType}}</span>
        </div>
        <div class="text">
          <span class="label">证件号码</span>
          <span>{{bean.insurederIdCard}}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-title">受益人</div>
      <template v-if="detail.beneficiaryType==2">
        <div v-for="(bean,i) in beneficiaryList" :key="i" class="text-item">
          <div class="text num">
            <span class="label">受益人{{i+1}}</span>
          </div>
          <div class="text">
            <span class="label">与被保人关系</span>
            <span>{{bean.beneRelationship|filterRelationShip}}</span>
          </div>
          <div class="text">
            <span class="label">姓名</span>
            <span>{{bean.beneName}}</span>
          </div>
          <div class="text">
            <span class="label">证件号码</span>
            <span>{{bean.beneIdCard}}</span>
          </div>
          <div class="text">
            <span class="label">受益比例</span>
            <span>{{bean.beneRate}}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="text">
          <span class="label">受益人</span>
          <span v-if="detail.beneficiaryType==1">法定受益人</span>
          <span v-if="detail.beneficiaryType==3">被保险人</span>
        </div>
      </template>
    </div>
    <div class="box" v-if="detail.additional&&detail.additional.length">
      <div class="box-title">附加险信息</div>
      <div class="text" v-for="(bean,i) in detail.additional" :key="i">{{bean.name}}：{{bean.amount}}</div>
    </div>
    <div class="bottom-box" v-if="!(pageFlag=='rhPage'&&detail.orderStatus==7) && !([2,3,5,9,-9].includes(detail.orderStatus)&&pageFlag=='rhPage')">
      <div class="btn" v-if="detail.orderStatus==1||detail.orderStatus==-9" @click="jumpPageToken(plat,detail.payUrl)" >立即支付</div>
      <div class="btn" v-else-if="detail.orderStatus==7" @click="jumpPageToken(plat,detail.manualUrl)">核保详情</div>
      <!-- 预核保成功 -->
      <div class="btn" v-if="detail.orderStatus==10" @click="jumpPageToken(plat,detail.payUrl)">继续投保</div>
      <!-- 代投跳转产品确认页 -->
      <div class="btn" v-if="detail.orderStatus==4&&detail.isReplaceInsure" @click="jumpPageToken(plat,detail.productUrl)">重新投保</div>
      <div class="btn" v-if="showCXTB && pageFlag!='rhPage'" @click="jumpPageToken(plat,detail.productUrl)">重新投保</div>
      <!-- 人核单详情按钮重新投保按钮显示条件 -->
      <div class="btn" v-if=" pageFlag=='rhPage'&&showRHCXTB" @click="jumpPageToken(plat,detail.productUrl)">重新投保</div>
      <div class="btn" v-if="detail.policyNo" @click="downloadPDF(detail.policyNo,detail.plat)">电子保单</div>
      <div class="btn" v-if="detail.supportRefund == 1" @click="jumpRefund()">退保</div>
    </div>
    <van-dialog v-model="show" className="downLoadDialog" title="下载" @confirm="confirmDownLoad" show-cancel-button confirm-button-color="#333333" cancel-button-color="#8A9095">
      <div slot="default">
        <img style="width:30px;height:30px" src="@static/images/order/pdf.png" />
        <span class="desc">{{pdfFileName}}</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {common} from "@/api/mixins";
import addPolicy from "./components/addPolicy";
import qualityBox from "./components/qualityBox";
export default {
  mixins:[common],
  components:{addPolicy,qualityBox},
  data() {
    return {
      policyType:'1',
      payType:{
        1:"年",
        2:"季",
        3:"月",
        4:"日",
        5:"半年",
        6:"岁"
      },
      feeActive:"",//服务费tab
      feeData:{},
      holder:{},//投保人
      insuresList:[],//被保人
      beneficiaryList:[],//受益人
      additionalList:[],//附加险
      rightList:[],//保障权益
      showYindao:false,//分享引导图
      level:"",
      tel:"",
      active: "",
      orderId: "",
      orderNo:"",
      detail: {},
      insuresList: [],
      status: "",
      plat:'',//A端B端
      policyNo:'',
      realPolicyNo:'',
      pdfFileName:"",
      downloadData:"",
      show: false,
      pageFlag:'',
    };
  },
  computed:{
    // 显示重新投保按钮
    showCXTB(){
      return [3,4,5,6,8].includes(this.detail.orderStatus*1)&&!this.detail.isReplaceInsure;
    },
    // 人核单页面显示重新投保按钮
    showRHCXTB(){
      return [4,6,8].includes(this.detail.orderStatus*1)&&!this.detail.isReplaceInsure;
    }
  },
  created() {
    if(!this.checkLogin()){
      return;
    }
    this.orderNo = this.$route.query.orderNo;
    this.policyNo = this.$route.query.policyNo;
    this.realPolicyNo = this.$route.query.realPolicyNo;
    this.plat = this.$route.query.plat;
    this.pageFlag = this.$route.query.pageFlag;
    this.policyType = sessionStorage.getItem('policyType')
    this.detailHttp();
  },
  methods: {
    // 跳转投保确认页
    // jumpProductOeder(item){
    //   let base = this.$config.env==1?"https://www.fxyf99.com":"https://fqyf.wts9999.net";
    //   location.href = base+"/m/product/premium_assist/"+this.orderNo;
    // },
    // 跳转退保页面
    jumpRefund() {
      // location.href = 'https://snmpaas.newchinalife.com/release/prod_install.html?hmsr=%E6%8E%8C%E4%B8%8A%E6%96%B0%E5%8D%8EApp&hmpl=%E6%8E%A8%E5%B9%BF%E6%9C%9F%E9%97%B4&hmcu=%E6%89%8B%E6%9C%BA%E6%89%AB%E7%A0%81&hmkw=%E4%B8%8B%E8%BD%BD&hmci=';
      this.$router.push({
        path: '/m/order/refund',
        query: {
          realPolicyNo: this.realPolicyNo,
          policyNo: this.policyNo,
          plat: this.plat,
          key: this.orderNo
        }
      })
    },
    // 电子保单下载
    downloadPDF(policyNo,plat){
      this.loading = true;
      this.$http({
        type: "GET",
        url: `/api/downloadPolicy/${plat}/${policyNo}`,
      }).then(res =>{
        this.loading = false
        if(res.data){
          this.show = true
          this.pdfFileName = `${policyNo}.pdf`
          this.downloadData = res.data
        }else{
          this.$notice.msg('电子保单暂未生成')
        }
      }).catch(e=>{this.loading = false})
    },
    confirmDownLoad(){
      if(this.downloadData){
        location.href = this.downloadData
      }else{
        this.$notice.msg('电子保单下载失败')
      }
    },
    // 跳转保障权益
    goBzqy(idCard){
      sessionStorage.jzy_bzqy = JSON.stringify(this.rightList)
      this.$router.push({
        path:"/m/order/bzqy",
        query:{
          idCard:idCard||'',
          productName:this.detail.productName
        }
      })
    },
    detailHttp: function() {
      this.loading = true;
      this.$http({
        type: "PUT",
        hideAlert:true,
        url: this.policyNo?`/api/queryPolicyDetail/${this.plat}/${this.policyNo}?`:`/api/queryOrderDetail/${this.plat}/${this.orderNo}`,
        data: {
          policyNo: this.realPolicyNo
          }
      }).then(resData => {
        this.loading = false;
        this.detail = resData.data;
        if(this.detail.doubleRecordStatus || this.detail.doubleRecordStatus===0){//int型转为string
          this.detail.doubleRecordStatus = this.detail.doubleRecordStatus.toString();
        }
        this.insuresList = JSON.parse(this.detail.insuredersJson)
        this.additionalList = this.detail.additionalList;
        this.rightList = JSON.parse(this.detail.garmtee)
        try{
          this.beneficiaryList = this.detail.beneInfo?JSON.parse(this.detail.beneInfo):[];
        }catch (e) {}
        this.$weixin.hideMenu();
      }).catch(e=>{
        console.log(e);
        this.loading = false;
        if(e.httpCode == "40401") {//不是自己的订单跳转个人中心
          this.$router.replace("/m/personal/index");
        }else if(e.httpCode&&e.msg){
          this.$notice.alert(e.msg);
        }
      });
    },
  },
  filters:{
    filterEndTime(val){
      if(val=='2888-01-01 00:00:00'){
        return '终身'
      }else if (!val) {
        return;
      }else{
        return val.substring(0, 10).replace(/-/g,'/');
      }
    },
    filterPayType(val){
      if(!val){
        return
      }else if(val==1){
        return '年'
      }else if(val==2){
        return '月'
      }else if(val==3){
        return '日'
      }
    },
    filterPay(val){
      if(!val){
        return
      }else if(val==1){
        return '年缴'
      }else if(val==2){
        return '月'
      }else if(val==3){
        return '日'
      }
    },
    filterFee(val){
      if(!val){
        return '0.00'
      }else{
        return val.toFixed(2)
      }
    },
    filterDoubleRecordStatus(val) {
      if (val == "0") {
        return "待双录";
      } else if (val == "-1") {
        return "审核失败";
      } else if (val == "1") {
        return "审核中";
      } else if (val == "2") {
        return "审核通过";
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./detail";
</style>
<style lang='scss'>
.downLoadDialog{
  border-radius: 10px;
  .van-dialog__header{
    font-size: 34px;
    font-weight: 500;
    line-height: 48px;
    color: #333333;
  }
  .van-dialog__content{
    word-break: break-all;
    padding:40px;
    >div{
      display: flex;
      align-items: flex-start;
      .desc{
        font-size: 28px;
        font-weight: 400;
        line-height: 40px;
        color: #666666;
        margin-left: 20px;
      }
    }
  }
  .van-dialog__message{
    font-size: 28px;
    color: #666666;
  }
  .van-dialog__footer{
    background: #E7E7E7;
    .van-button{
      background: #F5F7FA;
    }
    .van-dialog__cancel,.van-dialog__confirm{
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;

    }
    .van-dialog__cancel{
      color: #8A9095;
      border-right: 1px solid #E7E7E7;
    }
    .van-dialog__confirm{
      color: #333333;
    }
  }
}
</style>
